// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3w1NS","primary":"Button_primary__2_sNl"};